import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowBlue = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 500 800",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("style", { children: "\n      .arrow-blue-fill {\n        fill: url(#linear-gradient-arrow-blue-fill);\n      }\n    " }), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "linear-gradient-arrow-blue-fill",
		x1: 18.26,
		y1: 400,
		x2: 481.74,
		y2: 400,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#001fd0"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .07,
				stopColor: "#002cd6"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .25,
				stopColor: "#004be6"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .41,
				stopColor: "#005eef"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .52,
				stopColor: "#0165f3"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .67,
				stopColor: "#0d77f5"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .84,
				stopColor: "#1683f6"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#1a88f7"
			})
		]
	})] }), /* @__PURE__ */ _jsx("polygon", {
		className: "arrow-blue-fill",
		points: "99.14 16.96 481.74 399.27 481.16 399.85 481.74 400.43 99.14 783.04 18.26 701.86 320.27 399.85 18.26 97.84 99.14 16.96"
	})]
});
export default SvgArrowBlue;
